import { ObservableMap } from 'mobx';
import {
    IContextualMenuProps,
    IContextualMenuItem,
} from 'office-ui-fabric-react/lib/ContextualMenu';
import RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';
import { ComposeViewState, getStore } from 'owa-mail-compose-store';
import protectMessage from 'owa-mail-compose-actions/lib/actions/protectMessage';
import shouldDisableEncryptionButton from 'owa-mail-compose-actions/lib/utils/shouldDisableEncryptionButton';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import setIRMData from 'owa-mail-compose-actions/lib/actions/setIRMData';
import getEncryptionInfoBarMessageId from 'owa-mail-compose-actions/lib/utils/getEncryptionInfoBarMessageId';
import getMessageClassificationContextMenuItemProps from 'owa-mail-message-classification/lib/utils/getMessageClassificationContextMenuItemProps';
import clearClassification from 'owa-mail-message-classification/lib/utils/clearClassification';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getEncryptionDropDownSubMenu(
    viewState: ComposeViewState,
    templateIds: string[]
): IContextualMenuProps {
    const storeState = getStore();
    const { IRMData, clpViewState } = viewState;
    const { complianceConfigurations } = storeState;

    return {
        items: templateIds
            .map(templateId => {
                const itemTemplate = complianceConfigurations.get(templateId);
                if (itemTemplate) {
                    const menuItem = getBaseTemplateContextMenuItemProps(
                        itemTemplate,
                        IRMData,
                        viewState,
                        complianceConfigurations
                    );
                    menuItem.disabled =
                        shouldDisableEncryptionButton(viewState) ||
                        (clpViewState.selectedCLPLabel &&
                            clpViewState.selectedCLPLabel.isEncryptingLabel);
                    return menuItem;
                }
                return null;
            })
            .filter(item => item != null),
    };
}

export function getIRMTemplatesDropDown(viewState: ComposeViewState): IContextualMenuProps {
    const storeState = getStore();
    const { IRMData, classificationViewState } = viewState;
    const { complianceConfigurations, messageClassifications } = storeState;
    const subMenuItems = [];

    if (isFeatureEnabled('cmp-message-classification')) {
        messageClassifications.forEach(classification => {
            const menuItem = getMessageClassificationContextMenuItemProps(
                classification,
                classificationViewState,
                viewState,
                () => {
                    clearIrmData(viewState);
                }
            );
            subMenuItems.push(menuItem);
        });
    }

    complianceConfigurations.forEach(template => {
        const menuItem = getBaseTemplateContextMenuItemProps(
            template,
            IRMData,
            viewState,
            complianceConfigurations
        );
        menuItem.disabled = shouldDisableEncryptionButton(viewState);
        subMenuItems.push(menuItem);
    });

    return {
        items: subMenuItems,
    };
}

function getBaseTemplateContextMenuItemProps(
    template: RightsManagementLicenseDataType,
    IRMData: RightsManagementLicenseDataType,
    viewState: ComposeViewState,
    complianceConfigurations: ObservableMap<string, RightsManagementLicenseDataType>
): IContextualMenuItem {
    const { RmsTemplateId, TemplateName } = template;
    const { classificationViewState } = viewState;

    return {
        name: TemplateName,
        key: RmsTemplateId,
        onClick: () => {
            if (isFeatureEnabled('cmp-message-classification')) {
                clearClassification(classificationViewState, viewState);
            }
            if (IRMData && IRMData.RmsTemplateId === RmsTemplateId) {
                removeInfoBarMessage(viewState, getEncryptionInfoBarMessageId(RmsTemplateId));
                setIRMData(viewState, null);
            } else {
                protectMessage(viewState, complianceConfigurations, RmsTemplateId);
            }
        },
        canCheck: true,
        checked: IRMData && IRMData.RmsTemplateId == RmsTemplateId,
    };
}

export function clearIrmData(viewState: ComposeViewState) {
    const { IRMData } = viewState;
    if (IRMData) {
        removeInfoBarMessage(viewState, getEncryptionInfoBarMessageId(IRMData.RmsTemplateId));
        setIRMData(viewState, null /*IRMData*/);
    }
}
